import { App, Card, ConfigProvider, Layout } from 'antd';
import { Content, Footer } from 'antd/es/layout/layout';
import * as React from 'react';
import { RootStoreContext } from '../root-store-context';
import RootStore from '../stores/root-store';
import { CommunityTimeAllocator } from './communityTimeAllocator/CommunityTimeAllocator';


export default class Cat extends React.Component<{}, {}> {
  public render(): React.ReactElement<{}> {

    return (
      <ConfigProvider>
        <div style={{ height: "100%", width: "100%", boxSizing: "border-box" }}>
          <Card style={{
            background: "#fff",
            borderRadius: 12,
            width: "100%",
            height: "100%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
          }}>
            <RootStoreContext.Provider value={new RootStore()}>
              <Layout>
                <Content style={{ padding: 10 }}>
                  <App>
                    <CommunityTimeAllocator />
                  </App>
                </Content>
                <Footer></Footer>
              </Layout>
            </RootStoreContext.Provider>
          </Card>
        </div>
      </ConfigProvider>
    );
  }
}